<template>
    <center-container>
        <v-text-field
            v-model="answer"
            outlined
            autofocus
            counter="255"
            flat
        ></v-text-field>

        <skip-and-send-button
            @send="sendAnswer"
            @skip="$emit('skip')"
            :disabled="! answer || answer.length >= 255"
        ></skip-and-send-button>
    </center-container>
</template>

<script>
import SkipAndSendButton from './SkipAndSendButton.vue'
import CenterContainer from './CenterContainer.vue'

export default {
    components: {
        SkipAndSendButton,
        CenterContainer,
    },

    data: () => ({
        answer: null
    }),

    methods: {
        sendAnswer() {
            this.$emit('input', this.answer)
        }
    }
}
</script>
